import { BrowserWindow } from './window-provider';

export const getCurrentUrl = (window: Partial<BrowserWindow>) => window.location?.href;

export const getCurrentCanonicalUrl = (window: Partial<BrowserWindow>) =>
  window?.document?.querySelector?.('link[rel="canonical"]')?.getAttribute?.('href') ?? null;
